import { createElement, useState, useRef, useEffect } from '@max/max';
import Image from '@max/leez-image';
import AnimateView from '@max/mbc-animate-view';
import { Animated } from '@max/mbc-animated';
const isMRN = false;
import { _toPx } from '../../utils/style';
import { imageList } from '../../lib/constant';
import '../../common.scss';
export default function ButtonAnimation(props) {
    const { size } = props || {};
    const [showLottie, setShowLottie] = useState(false);
    const animateOpacityValue = useRef(new Animated.Value(1)).current;
    const animateScaleValue = useRef(new Animated.Value(0)).current;
    const playAnimation = () => {
        Animated.sequence([Animated.timing(animateScaleValue, {
                toValue: 0,
                duration: 0,
                delay: 2300,
                useNativeDriver: false
            }), Animated.loop(Animated.sequence([Animated.timing(animateScaleValue, {
                    toValue: 1.1,
                    duration: 200,
                    delay: 0,
                    useNativeDriver: false
                }), Animated.timing(animateScaleValue, {
                    toValue: 0.96,
                    duration: 150,
                    delay: 0,
                    useNativeDriver: false
                }), Animated.timing(animateScaleValue, {
                    toValue: 1.03,
                    duration: 150,
                    delay: 0,
                    useNativeDriver: false
                }), Animated.timing(animateScaleValue, {
                    toValue: 1,
                    duration: 150,
                    delay: 0,
                    useNativeDriver: false
                }), Animated.timing(animateOpacityValue, {
                    toValue: 0,
                    duration: 150,
                    delay: 1400,
                    useNativeDriver: false
                }), Animated.timing(animateScaleValue, {
                    toValue: 0,
                    duration: 100,
                    delay: 0,
                    useNativeDriver: false
                })]), {
                iterations: Infinity,
                resetBeforeIteration: true
            })]).start(() => { });
    };
    useEffect(() => {
        playAnimation();
        setTimeout(() => {
            setShowLottie(true);
        }, 2300);
    }, []);
    const animateStyle = {
        position: 'absolute',
        right: _toPx(-9),
        bottom: 0,
        zIndex: 1,
        opacity: animateOpacityValue,
        transform: [{
                scale: animateScaleValue
            }]
    };
    const imageWidthMrn = _toPx(size === 'big' ? 45 : 38);
    const imageHeightMrn = _toPx(size === 'big' ? 50 : 42);
    const imageWidth = _toPx(size === 'big' ? 40 : 33);
    const mrnImageStyle = {
        position: 'absolute',
        zIndex: 100,
        bottom: 0,
        right: _toPx(-9)
    };
    return <>
      
      <AnimateView animateStyles={animateStyle}>
        <Image width={imageWidth} widthAuto source={{
            uri: imageList.expandArrow
        }} placeholder={false}/>
      </AnimateView>
    </>;
}
